import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { useViewport } from '@/hooks';
import { TrashIcon } from '@/icons';
import { IconButton, Tooltip } from '@/ui_v3';
import { useIsQuestionCardAiTarget } from '../../../features/question-card-ai/hooks/useIsQuestionCardAiTarget';
import { useQuizList } from '../../useQuizList';
import { useQuizControl } from '../QuizControlProvider';
export const QuizDeleteButton = ({
  disabled
}: {
  disabled?: boolean;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    isMobile
  } = useViewport();
  const {
    handleDelete
  } = useQuizList();
  const {
    id,
    index
  } = useQuizControl();
  // 이 카드가 AI 작업의 원본이면 끝날 때까지 복제·삭제를 잠근다(결과 폐기·리비전 꼬임 방지).
  const isAiTarget = useIsQuestionCardAiTarget(id);
  const isDisabled = disabled || isAiTarget;
  return <Tooltip.Provider disableHoverableContent={isMobile} data-sentry-element="unknown" data-sentry-component="QuizDeleteButton" data-sentry-source-file="QuizDeleteButton.tsx">
      <Tooltip.Root data-sentry-element="unknown" data-sentry-source-file="QuizDeleteButton.tsx">
        <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="QuizDeleteButton.tsx">
          <IconButton size="xs" onMouseDown={e => {
          e.preventDefault();
          e.stopPropagation();
        }} variant="outlined" intent="neutral" className="hidden mobile-lg:flex" disabled={isDisabled} onClick={() => {
          void handleDelete(index, {
            position: 'card_button'
          });
        }} data-sentry-element="IconButton" data-sentry-source-file="QuizDeleteButton.tsx">
            <TrashIcon size="xs" fill={isDisabled ? ICON_COLOR.disabled : ICON_COLOR.default} data-sentry-element="TrashIcon" data-sentry-source-file="QuizDeleteButton.tsx" />
          </IconButton>
        </Tooltip.Trigger>
        <Tooltip.Content data-sentry-element="unknown" data-sentry-source-file="QuizDeleteButton.tsx">{t('global.delete')}</Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>;
};